module.exports = __webpack_public_path__ + "static/img/yunyan-11.5885e5b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yunyan-11.jpg
// module id = 18NI
// module chunks = 1